import { z } from "zod";

export const quickReplyItemPublicSchema = z.object({
  id: z.string(),
  label: z.string(),
  message_text: z.string(),
});

export const quickRepliesPublicSchema = z.object({
  enabled: z.boolean(),
  items: z.array(quickReplyItemPublicSchema),
});

export type QuickRepliesPublicConfig = z.infer<typeof quickRepliesPublicSchema>;

export const QUICK_REPLIES_DISABLED: QuickRepliesPublicConfig = {
  enabled: false,
  items: [],
};

export function parseQuickRepliesPublicConfig(raw: unknown): QuickRepliesPublicConfig {
  const parsed = quickRepliesPublicSchema.safeParse(raw);
  if (!parsed.success) {
    return { ...QUICK_REPLIES_DISABLED };
  }
  return parsed.data;
}
